export class DataImportColumnModel {
  constructor(data={}) {
    this._id = data?._id || null;

    this.name = data.name || '';
    this.type = data.type || '';
    this.isRequired = data.isRequired? Number(data.isRequired): 0;

    this.style = data.style || { minWidth: 140 };
  }
}
